function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  x: "-21.9%",
  y: "-15.6%",
  width: "143.8%",
  height: "143.8%",
  filterUnits: "objectBoundingBox",
  id: "RadioUnchecked_svg__24_a"
}, React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0534309441 0",
  in: "shadowBlurOuter1"
})), React.createElement("circle", {
  id: "RadioUnchecked_svg__25_b",
  cx: 8,
  cy: 8,
  r: 8
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#RadioUnchecked_svg__24_a)",
  xlinkHref: "#RadioUnchecked_svg__25_b"
}), React.createElement("circle", {
  stroke: "#C0D0DF",
  strokeLinejoin: "square",
  fill: "#FFF",
  cx: 8,
  cy: 8,
  r: 7.5
}));

var SvgRadioUnchecked = function SvgRadioUnchecked(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
};

export default SvgRadioUnchecked;